import { apiUrl, client } from "../modules/store";
import { deepParse } from "./helpers/jsonParser";

export function getLastSyncCacheInvalidated() {
  return client.get(`${apiUrl}/organizations/syncInvalidated`);
}

export function uploadLogo(form) {
  return client.post(`${apiUrl}/organizations/logo/`, form);
}

export function getLogo() {
  return client
    .get(`${apiUrl}/organizations/logo`, {
      responseType: "blob",
    })
    .then((res) => res);
}

export function getOrgLogo(customerId) {
  return client
    .get(`${apiUrl}/organizations/logo/${customerId}`, {
      responseType: "blob",
    })
    .then((res) => res);
}

export function getOrganizationFromLocalStorage() {
  const organization = localStorage.getItem("persist:organization");
  if (organization) {
    return deepParse(organization);
  }
  return null;
}

export function purgeAttachments(orgId) {
  return client.post(`${apiUrl}/organizations/purgeAttachments/${orgId}`);
}
